import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-arrow-down",
  "use": "icon-icon-arrow-down-usage",
  "viewBox": "0 0 8 5",
  "content": "<symbol viewBox=\"0 0 8 5\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-arrow-down\">\n<path d=\"M4.23084 4.62682L1.04218 1.08387C0.897391 0.922987 1.01156 0.666626 1.22801 0.666626H7.60533C7.82177 0.666626 7.93594 0.922986 7.79115 1.08387L4.60249 4.62682C4.50318 4.73717 4.33015 4.73717 4.23084 4.62682Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol